











import Vue from "vue";
import { mapState } from "vuex";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import { v4 as uuidv4 } from "uuid";
import { get } from "lodash";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },

    props: {
        phoneType: {
            type: String,
            required: true,
            default: ""
        },
    },

    data: function() {
        return {
            uniqueId: uuidv4(),
        };
    },

    computed: {
        ...mapState("CustomersModule", ["currentCustomer", "initialCustomer"]),
        pathInStore: function(): string {
            return `contactDetails.${this.phoneType}.contactHours`;
        },
        callingTimes: function(): string|null {
            if (this.currentCustomer && this.currentCustomer.contactDetails && Object.keys(this.currentCustomer.contactDetails).length > 0) {
                if (this.phoneType === "mobile") {
                    const contactDetailsMobile = this.currentCustomer.contactDetails.mobile;
                    if (contactDetailsMobile) {
                        return contactDetailsMobile.contactHours;
                    }
                }

                if (this.phoneType === "landline") {
                    if (this.currentCustomer.contactDetails.landline) {
                        const contactDetailsLandline = this.currentCustomer.contactDetails.landline;
                        if (contactDetailsLandline) {
                            return contactDetailsLandline.contactHours;
                        }
                    }
                }
            }
            return null;
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("call_timing_preference_anytime"),
                    "value": "ANYTIME"
                },
                {
                    "label": this.$t("call_timing_preference_afternoon"),
                    "value": "AFTERNOON"
                },
                {
                    "label": this.$t("call_timing_preference_evening_only"),
                    "value": "EVENING_ONLY"
                },
                {
                    "label": this.$t("call_timing_preference_morning_evening"),
                    "value": "MORNING_EVENING"
                },
                {
                    "label": this.$t("call_timing_preference_morning_only"),
                    "value": "MORNING_ONLY"
                },
                {
                    "label": this.$t("call_timing_preference_weekend_only"),
                    "value": "WEEKEND_ONLY"
                },
                {
                    "label": this.$t("call_timing_preference_working_hours"),
                    "value": "WORKING_HOURS"
                },
            ];
        }
    },
    mounted: function() {
        // if (this.$store.getters["FormModule/getValue"](this.pathInStore) == null) {
        //     this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: "ANYTIME"});
        // }
    },
    methods: {
        updateValue: function(callingTimesValue: number): void {
            if (this.currentCustomer) {
                this.$store.commit("CustomersModule/addValue", {path: this.pathInStore, value: callingTimesValue});

                if (this.initialCustomer) {
                    const initialContactDetails = this.initialCustomer.contactDetails;
                    if (initialContactDetails && Object.keys(initialContactDetails).length > 0) {

                        if (this.phoneType === "mobile") {

                            const initialMobileContactHours = get(initialContactDetails, "mobile.contactHours");
                            const currentMobileContactHours = get(this.currentCustomer, "contactDetails.mobile.contactHours");

                            if ((initialMobileContactHours && currentMobileContactHours) && initialMobileContactHours !== currentMobileContactHours) {
                                this.$store.commit("CustomersModule/setIsCustomerContactDetailsChange", true);
                            } else {
                                this.$store.commit("CustomersModule/setIsCustomerContactDetailsChange", false);
                            }
                        }

                        if (this.phoneType === "landline") {

                            const initialLandlineContactHours = get(initialContactDetails, "landline.contactHours");
                            const currentLandlineContactHours = get(this.currentCustomer, "contactDetails.landline.contactHours");

                            if ((initialLandlineContactHours && currentLandlineContactHours) && initialLandlineContactHours !== currentLandlineContactHours) {
                                this.$store.commit("CustomersModule/setIsCustomerContactDetailsChange", true);
                            } else {
                                this.$store.commit("CustomersModule/setIsCustomerContactDetailsChange", false);
                            }
                        }
                    }
                }
            } else {
                this.$store.commit("FormModule/addValueUI", {path: "customer." + this.pathInStore, value: callingTimesValue});
            }
        }
    },
});
